import { FC, useState } from "react"
import {
  IOzonOrder,
  setOzonNewOrders,
} from "../../../app/reducers/ordersReducer"
import s from "../NewOrders.module.css"
import { useAppDispatch } from "../../../app/hooks"
import { FormOzonKatrenOrder } from "../../FormKatrenOrder/ozon/FormOzonKatrenOrder"
import { StorageSelectControl } from "../../StorageSelect/StorageSelectControl"
import { MARKETPLACE } from "@acc/shared"
import { Button, Box } from "@radix-ui/themes"
import { DataTable, type DataTableColumn } from "../../DataTable/DataTable"

const columns: DataTableColumn<IOzonOrder>[] = [
  { key: "postingNumber", header: "Номер отправления." },
  {
    key: "products",
    header: "Список товаров в отправлении.",
    cell: (el) => (
      <>
        {el.products.map((p) => (
          <p key={p.offer_id}>
            {p.offer_id} {p.price} {p.currency_code}
          </p>
        ))}
      </>
    ),
  },
]

export const OzonNewOrders: FC<{
  orders: IOzonOrder[]
  storages: {
    name: string
    warehouse_id: number
  }[]
}> = ({ orders, storages }) => {
  const [selectedStorageId, setSelectedStorages] = useState("")
  const dispatch = useAppDispatch()
  const ordersFromSelectedWarehouse =
    orders.filter((ord) =>
      selectedStorageId ? +ord.warehouseId === +selectedStorageId : true,
    ) || []
  return (
    <Box px="4">
      <div className={s.orderContent}>
        <div className={s.table}>
          <StorageSelectControl
            label="Отфильтровать по складу"
            value={selectedStorageId}
            onChange={(value) => {
              setSelectedStorages(value)
            }}
            controlKey="ozon-storages-select"
            marketplace={MARKETPLACE.OZON}
          />
          <DataTable
            columns={columns}
            data={ordersFromSelectedWarehouse}
            rowKey={(el, i) => el.postingNumber + "-" + i}
            rowClassName={() => s.rowValue}
          />
        </div>
        <div className={s.buttons}>
          <Button onClick={() => dispatch(setOzonNewOrders())}>
            Обновить список заказов
          </Button>
          <FormOzonKatrenOrder
            orders={ordersFromSelectedWarehouse}
            isDisabled={!selectedStorageId}
          />
        </div>
      </div>
    </Box>
  )
}
